import { createApp } from 'vue'
import StafetFlowLightBagsMetaList from './StafetLysPoserList'

const el = '.kb-component--stafet-flow-light-bags-meta-list'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetFlowLightBagsMetaListDOM) => {
            const component = createApp(StafetFlowLightBagsMetaList).use(Store)
            component.mount(StafetFlowLightBagsMetaListDOM)
        })
    }
}
